import React from 'react';
import { domToReact } from 'html-react-parser';
const parse = require('html-react-parser').default;

interface HtmlRendererProps {
  html: any
  components?: any
  componentOverrides?: any
}

const Renderer = ({ html = '', components = {}, componentOverrides = {} }: HtmlRendererProps) => {
  const resolvedComponents = Object.keys(componentOverrides).reduce(
    (acc, key) => {
      const Comp = components[key] || ((props: any) => React.createElement(key, props));

      acc[key] = componentOverrides[key](Comp);

      return acc;
    },
    { ...components },
  );

  const parserOptions = {
    replace: ({ name, attribs, children: nodeChildren }: any) => {
      const children = nodeChildren ? domToReact(nodeChildren, parserOptions) : null;

      const Comp = resolvedComponents[name];

      if (!Comp) {
        return;
      }

      return React.createElement(Comp, { name, ...attribs }, children);
    },
  };

  return (
    <>
      {parse(html, parserOptions)}
    </>
  );
};

export default Renderer;
